import { memo, useContext, createElement } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './index.scss';
import { onHotCityRouteClick } from '../../utils/index';
const RouteCard = (props) => {
    const { city, hotCityRouteArrowColor, hotCityRouteDurationColor, hotCityRoutePriceBgColor, hotCityRoutePriceTextColor, backgroundColor, key } = props;
    const ctx = useContext(global._EngineGlobalContext);
    const reportClickCardMC = () => {
        var _a;
        const val_lab = {
            custom: {
                component_name: '火车票千人千面组件',
                depart_city_name: city.fromCityNameText,
                arrive_city_name: city.toCityNameText,
                mode: '无图模式'
            }
        };
        (_a = ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mcReport('b_daodian_lowcode_npt6cewk_mc', {
            valLab: val_lab
        });
        onHotCityRouteClick(city);
    };
    return <View className="hot-city-route-block" onClick={() => reportClickCardMC(city)} style={key % 2 === 0 ? {
        paddingLeft: '6rpx'
    } : {
        paddingRight: '6rpx'
    }}>
      <View className="hot-city-route-block-inner-container">
        <View className="hot-city-route-block-info">
          <View className="hot-city-route-block-info-city">
            <Text className="hot-city-route-block-info-from-city" numberOfLines={1} style={{
        textOverflow: 'ellipsis'
    }}>
              {city.fromCityNameText}
            </Text>
            <Text style={{
        color: hotCityRouteArrowColor,
        fontSize: '26rpx'
    }}> ⇀ </Text>
            <Text className="hot-city-route-block-info-to-city" numberOfLines={1} style={{
        textOverflow: 'ellipsis'
    }}>
              {city.toCityNameText}
            </Text>
          </View>
          <Text className="hot-city-route-block-info-duration" style={{
        color: hotCityRouteDurationColor
    }}>
            {city.runTime}到达
          </Text>
        </View>
        <View className="hot-city-route-block-price" style={{
        backgroundColor: hotCityRoutePriceBgColor,
        color: hotCityRoutePriceTextColor
    }}>
          <Text className="hot-city-route-block-price-text" style={{
        fontSize: '16rpx',
        lineHeight: '16rpx',
        marginBottom: '-7rpx',
        color: hotCityRoutePriceTextColor
    }}>
            ￥
          </Text>
          <Text className="hot-city-route-block-price-text" style={{
        color: hotCityRoutePriceTextColor
    }}>
            {city.priceText}
          </Text>
        </View>
        <View className="hot-city-route-block-left-circle" style={{
        backgroundColor
    }}></View>
        <View className="hot-city-route-block-right-circle" style={{
        backgroundColor
    }}></View>
      </View>
    </View>;
};
export default memo(RouteCard);
